import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Draggable"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.5 3.75H10.5V6.75H7.5V3.75ZM13.5 3.75H16.5V6.75H13.5V3.75ZM7.5 10.5H10.5V13.5H7.5V10.5ZM13.5 10.5H16.5V13.5H13.5V10.5ZM7.5 17.25H10.5V20.25H7.5V17.25ZM13.5 17.25H16.5V20.25H13.5V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Draggable.vue"]]);
